import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_client_btn = _resolveComponent("edit-client-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_delete_client_btn = _resolveComponent("delete-client-btn")!
  const _component_show_client_users_btn = _resolveComponent("show-client-users-btn")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    icon: "fa fa-ellipsis",
    title: "Client Actions",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_ctx.isGranted('EDIT_CLIENT'))
            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                key: 0,
                class: "q-pa-none",
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_edit_client_btn, {
                    client: _ctx.client,
                    class: "full-width",
                    align: "left",
                    flat: "",
                    "no-caps": ""
                  }, null, 8, ["client"])
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            : _createCommentVNode("", true),
          _createVNode(_component_q_separator),
          (_ctx.isGranted('DELETE_CLIENT'))
            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                key: 1,
                class: "q-pa-none",
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_delete_client_btn, {
                    client: _ctx.client,
                    align: "left",
                    class: "full-width",
                    flat: ""
                  }, null, 8, ["client"])
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            : _createCommentVNode("", true),
          (_ctx.isGranted('VIEW_USERS'))
            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                key: 2,
                class: "q-pa-none",
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_show_client_users_btn, {
                    client: _ctx.client,
                    align: "left",
                    class: "full-width",
                    flat: ""
                  }, null, 8, ["client"])
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}